import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { HStack, Pressable, Text, TextArea, VStack, useTheme, } from "native-base";
import { isWeb } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import Icon from "../icons/Icon";
import Button from "../atoms/Button";
import { cropFilename } from "../util/strings";
import useResponsive from "../util/useResponsive";
import Select from "../atoms/Select";
import { DOCUMENT_SERVICE_FOR_HUMANS, DocumentService, } from "../form/upload/model";
const DocumentItem = ({ variant = "primary", size = "md", isButton = false, onPress, iconName = "documentBlank", iconSize = "xl", label, subText, comment, onChangeComment, onChangeService, isEditable = false, }) => {
    var _a, _b;
    const { colors } = useTheme();
    const { fontSizes } = useTheme();
    const [editing, setEditing] = useState(false);
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const variants = useMemo(() => ({
        "2xs": {
            labelSize: fontSizes.sm,
            lineHeight: 1,
        },
        xs: {
            labelSize: fontSizes.sm,
            lineHeight: 1,
        },
        sm: {
            labelSize: fontSizes.sm,
            lineHeight: 1,
        },
        md: {
            labelSize: fontSizes.sm,
            lineHeight: 1,
        },
        lg: {
            labelSize: fontSizes.md,
            lineHeight: 1,
        },
        xl: {
            labelSize: fontSizes.md,
            lineHeight: 1,
        },
        "2xl": {
            labelSize: fontSizes["2xl"],
        },
        "3xl": {
            labelSize: fontSizes.lg,
            subTextSize: fontSizes.sm,
        },
    }), [fontSizes]);
    const iconSizes = useMemo(() => ({
        xs: 16,
        sm: 18,
        md: 20,
        lg: 20,
        xl: 20,
        "2xl": 28,
    }), []);
    const iconVariants = useMemo(() => ({
        primary: colors.white,
        destructive: colors.white,
        gray: colors.gray[800],
        outlined: colors.gray[800],
        ghost: colors.gray[900],
        ghostGreen: colors.green[500],
        link: colors.green[600],
        ghostLink: colors.gray[800],
        ghostGrayLink: colors.gray[500],
        black: "black",
    }), [colors]);
    const packageChoices = useMemo(() => [
        {
            value: DocumentService.Pregnancy,
            label: t(`${DOCUMENT_SERVICE_FOR_HUMANS[DocumentService.Pregnancy]}`),
        },
        {
            value: DocumentService.Manager,
            label: t(`${DOCUMENT_SERVICE_FOR_HUMANS[DocumentService.Manager]}`),
        },
        {
            value: DocumentService.PrePostOp,
            label: t(`${DOCUMENT_SERVICE_FOR_HUMANS[DocumentService.PrePostOp]}`),
        },
    ], [t]);
    const handleServiceChange = (value) => {
        onChangeService === null || onChangeService === void 0 ? void 0 : onChangeService(value);
    };
    return (_jsxs(VStack, Object.assign({ flex: 1, flexDirection: "row" }, { children: [_jsx(Pressable, Object.assign({ onPress: onPress, disabled: !isButton }, { children: _jsx(Icon, { name: iconName, fill: iconVariants[variant], size: iconSizes[iconSize] }) })), _jsxs(VStack, Object.assign({ ml: 2, width: "100%", alignItems: "flex-start", justifyContent: "center" }, { children: [_jsx(Text, Object.assign({ lineHeight: "1.1em", fontWeight: "bold" }, { children: label && cropFilename(label, isSmallScreen ? 30 : 50) })), subText && (_jsx(Text, Object.assign({ color: "gray.600", lineHeight: "1.1em", mt: 1, fontWeight: "500", fontSize: (_a = variants[size].subTextSize) !== null && _a !== void 0 ? _a : fontSizes.xs }, { children: subText }))), !editing && comment && (_jsx(Text, Object.assign({ color: "gray.600", lineHeight: "1.1em", fontWeight: "500", mt: 2, fontSize: (_b = variants[size].subTextSize) !== null && _b !== void 0 ? _b : fontSizes.xs }, { children: comment }))), _jsxs(HStack, Object.assign({ alignItems: editing ? "flex-start" : "flex-end", direction: editing ? "column" : "row", space: 2, width: "100%", pt: 3 }, { children: [_jsx(Select, { choices: packageChoices, placeholder: t("selectPackage"), onChange: handleServiceChange }), isEditable && editing && (_jsx(TextArea, { value: comment !== null && comment !== void 0 ? comment : undefined, autoCompleteType: "off", h: 20, mt: isWeb ? 2 : 0, placeholder: t("addComment") + "...", onChangeText: onChangeComment, width: "95%" })), isEditable && !editing && (_jsx(Button, Object.assign({ variant: "outlined", size: "xs", mt: 2, mb: isWeb ? 0 : 2, transparent: true, onPress: () => setEditing(true), leftIconName: "add" }, { children: t("addComment") })))] }))] }))] })));
};
export default DocumentItem;
